import React from "react";
import { Link } from "react-router-dom";
import { FileText } from "lucide-react";

const EFFECTIVE = "June 2026";

export default function Terms() {
  return (
    <div className="max-w-2xl mx-auto animate-slide-up py-4" data-testid="terms-page">
      <div className="flex items-center gap-2 text-race-red mb-2">
        <FileText size={16} />
        <span className="overline">Terms of Service</span>
      </div>
      <h1 className="font-heading text-4xl sm:text-5xl tracking-tight">Terms of Service</h1>
      <p className="text-race-sub mt-2 text-sm">Effective {EFFECTIVE} · Text Racing (sanctioned by IBRA)</p>

      <div className="mt-6 space-y-6 text-race-txt leading-relaxed text-sm sm:text-base">
        <section>
          <h2 className="font-heading text-2xl mb-2">Acceptance</h2>
          <p>By creating an account or using Text Racing, you agree to these Terms and to our <Link className="text-race-red" to="/privacy">Privacy Policy</Link> and <Link className="text-race-red" to="/messaging-policy">Messaging Policy</Link>. If you do not agree, do not use the service.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-2">Eligibility</h2>
          <p>You must be at least 18 years old and located in a permitted region to enter paid contests. Text Racing is a game of skill; contest availability may be restricted where required by law.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-2">Accounts &amp; conduct</h2>
          <p>You are responsible for your account and for accurate information. Cheating, automation, multi-accounting, or interfering with other racers is prohibited and may result in disqualification, forfeiture of prizes, or account termination.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-2">Credits, entries &amp; prizes</h2>
          <p>Credits are used to enter contests and may be purchased. Contest results are determined by our server-authoritative scoring. Prizes are awarded per each contest’s stated rules. Identity verification (KYC) may be required before any payout.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-2">Messaging</h2>
          <p>If you opt in, we send SMS race reminders as described in our <Link className="text-race-red" to="/messaging-policy">Messaging Policy</Link>. Message &amp; data rates may apply; reply STOP to opt out at any time.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-2">Disclaimers &amp; liability</h2>
          <p>The service is provided “as is.” To the fullest extent permitted by law, Text Racing is not liable for indirect or consequential damages. Carriers are not liable for delayed or undelivered messages.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-2">Changes &amp; contact</h2>
          <p>We may update these Terms; continued use means acceptance. Questions: <a className="text-race-red" href="mailto:support@textracing.com">support@textracing.com</a>.</p>
        </section>
      </div>

      <div className="mt-8 flex gap-3 flex-wrap">
        <Link to="/messaging-policy" className="text-sm border border-race-line px-4 py-2 rounded-sm hover:border-race-red transition-colors">Messaging Policy</Link>
        <Link to="/privacy" className="text-sm border border-race-line px-4 py-2 rounded-sm hover:border-race-red transition-colors">Privacy Policy</Link>
      </div>
    </div>
  );
}
